import { Check, Copy } from 'lucide-react-native'
import { Button } from '@chillout/ui'
import { ModalActions } from './Modal'

interface CopyModalActionsProps {
  copied: boolean
  copyLabel: string
  copiedLabel: string
  doneLabel: string
  onCopy: () => void
  onDone: () => void
}

export function CopyModalActions({ copied, copyLabel, copiedLabel, doneLabel, onCopy, onDone }: CopyModalActionsProps) {
  return (
    <ModalActions>
      <Button label={doneLabel} variant="secondary" className="flex-1" onPress={onDone} />
      <Button
        label={copied ? copiedLabel : copyLabel}
        variant="primary"
        className="flex-1"
        LeftIcon={copied ? Check : Copy}
        onPress={onCopy}
      />
    </ModalActions>
  )
}